import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface OnBeforeUnload {
  beforeUnloadPluginFlg: () => boolean;
  beforeUnloadPluginAction: () => boolean;
}

@Injectable()
export class BeforeunloadPlugin implements CanDeactivate<OnBeforeUnload> {
  canDeactivate(component: OnBeforeUnload) {
    console.log('canDeactivate');
    if (component.beforeUnloadPluginFlg()) {
      return component.beforeUnloadPluginAction();
    }
    return false;
  }
}
